import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { take, takeUntil, filter } from 'rxjs/operators';
import { AppState } from 'src/app/data/models/app-state';
import * as fromFB from './../../form-designer/fb-state/reducers/fb.reducer';
import { FdDetailNavSectionService } from '../../form-designer/fd-detail-nav-section/fd-detail-nav-section.service';
import { FbModuleService } from '../fb-module.service';
import { ReferenceLibraryService } from 'reference-library';
import { ReferenceLibrary, TreeNode } from 'app-models';
import { FormType } from '../../form-designer/form-type.enum';
import { CustomButtonActionService } from 'custom-button-action';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FbPopUpSimpleFormComponent } from '../fb-pop-up-simple-form/fb-pop-up-simple-form.component';
import * as FB from './../../form-designer/fb-state/actions/fb.actions';
import { MarkCleanFormAction, selectFormDirty } from 'dirty-check-store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { AppServicesLibraryService } from 'app-services-library';
import { FormDesignerService } from '../../form-designer/form-designer.service';


@Component({
  selector: 'app-fb-container',
  templateUrl: './fb-container.component.html',
  styleUrls: ['./fb-container.component.scss', '../fb-module.component.scss']
})
export class FbContainerComponent implements OnInit, OnDestroy {
  isFBModulePreview = false;
  isFBUser: boolean;
  formBuilderId: number;
  formBuilderInfo: any;
  showPageInfo: boolean;
  pageFormType: string;
  showSimpleForm: boolean = null;
  showPageTitleSection = false;
  simpleFormButton: any;
  fbPageTypeArr: ReferenceLibrary[];
  formTypeSelected: string;
  moduleList: any[];
  observableSubscription$ = new Subject();
  selectedMenu: TreeNode;
  formDataId: any;
  isMultiStepForm: boolean = null;
  isOpenPopUp = false;
  steps: any[] = [];
  onBackToMasterListReference: any;
  buttonClicked: boolean = false;
  dashboardInfo: {
    dashboardType: string;
    dashboardTemplate: string;
    titleToRedirectPageFormId?: any;
    notificationTypeRedirectPageFormId?: any
  } | null;
  interviewRounds: any;
  isMultiDataSrc: any;
  interviewProcessId: any;
  dashboardLinkEnabled: boolean;

  constructor(
    private store: Store<AppState>,
    private fdDetailNavSectionService: FdDetailNavSectionService,
    private fbModuleService: FbModuleService,
    private referenceLibraryService: ReferenceLibraryService,
    private customButtonActionService: CustomButtonActionService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private ngxService: NgxUiLoaderService,
    private appServicesLibraryService: AppServicesLibraryService,
    private formDesignerService: FormDesignerService
  ) {
    this.showPageInfo = false;
    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
  }

  ngOnInit() {
    this.fbModuleService.onPageOpenSubject
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((item: TreeNode) => {
        this.onPageOpen(item);
      });

    this.customButtonActionService.onLinkRedirectPageSubject.pipe(takeUntil(this.observableSubscription$))
      .subscribe((item: any) => {
        if (item.setFormDataId) {
          this.formDataId = 'formDataId' in sessionStorage ? Number(sessionStorage.getItem('formDataId')) : null;
        }
        this.onLinkRedirect(item);
      });

    if ('presentMenu' in sessionStorage) {
      this.selectedMenu = (JSON.parse(sessionStorage.getItem('presentMenu')) as TreeNode);
      this.formBuilderId = this.selectedMenu.pageFormId;
      this.pageFormType = FormType[this.selectedMenu.formType];
      this.getPageFormInfo(false, true);
      sessionStorage.removeItem('presentMenu');
    } else {
      combineLatest([
        this.store.select(fromFB.getIsFBModulePreview),
        this.store.select(fromFB.getFormBuilderId)
      ])
        .pipe(take(1))
        .subscribe((response: any[]) => {
          this.isFBModulePreview = response[0];
          if (this.isFBModulePreview && response[1]) {
            this.formBuilderId = response[1];
            this.onPreview();
          } else if (this.isFBUser) {
            this.onLogin();
          }
        });
    }
    //this.openPopup();
  }

  openPopup() {
    const dialogRef = this.dialog.open(FbPopUpSimpleFormComponent, {
      width: 'calc(100vw - 100px)',
      height: 'calc(100vh - 100px)',
      data: {
        simpleFormButton: this.simpleFormButton,
        pageFormType: this.pageFormType,
        formTypeSelected: this.formTypeSelected,
        isFBModulePreview: this.isFBModulePreview,
        formBuilderInfo: this.formBuilderInfo,
        formDataId: this.formDataId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onLinkRedirect(item: any) {
    this.dirtyCheckForFormsBuilder(item, 'REDIRECT');
    this.dashboardLinkEnabled = this.formDesignerService.getDashboardLink();
    if (this.dashboardLinkEnabled) {
      const redId = sessionStorage.getItem('redirectId');
      this.formDesignerService.setRedirectId(redId);
    }
  }
  onHandleRedirectPage(item: any) {
    this.showPageInfo = false;
    if (item?.formType === 1482) {
      this.fdDetailNavSectionService.setisRedirectClicked(true);
    } else if (item?.formType === 1483) {
      this.fdDetailNavSectionService.setisRedirectClicked(false);
    }
    if (item?.pageFormId && item?.formType) {
      this.pageFormType = null;
      this.formBuilderInfo = null;
      this.showPageTitleSection = false;
      this.showSimpleForm = false;
      this.isMultiStepForm = false;
      this.simpleFormButton = null;
      setTimeout(() => {
        this.formBuilderId = item.pageFormId;
        this.pageFormType = FormType[item.formType];
        this.getPageFormInfo(false, true);
      }, 0);
    } else if (item && !item.pageFormId) {
      this.showPageInfo = true;
      this.pageFormType = null;
      this.formBuilderInfo = null;
      this.showPageTitleSection = false;
      this.showSimpleForm = false;
      this.isMultiStepForm = false;
      this.simpleFormButton = null;
    } else {
      this.showPageInfo = true;
    }
  }

  onLogin() {
    this.moduleList = 'fbModuleList' in sessionStorage ? JSON.parse(sessionStorage.getItem('fbModuleList')) : null;
    if (this.moduleList?.length > 0) {
      const defaultModule = this.moduleList.find(x => x.defaultModule);
      let moduleId;
      if (defaultModule) {
        moduleId = defaultModule.moduleId;
      } else {
        moduleId = this.moduleList[0].moduleId;
      }
      // moduleId = 37;
      this.fbModuleService.onLoadMenuList.next({
        moduleId: moduleId,
        formBuilderInfo: null
      });
    }
  }

  onPreview() {
    this.getPageFormInfo(true);
  }

  getPageFormInfo(isGetMenuList, onMenuClick: boolean = false) {
    this.fdDetailNavSectionService.getPageFormById(this.formBuilderId)
      .pipe(take(1)).subscribe((formBuilderInfo: any) => {
        if (formBuilderInfo) {
          const fbRoleId = 'fbRoleId' in sessionStorage ? Number(sessionStorage.getItem('fbRoleId')) : null;
          if (formBuilderInfo.fbPageFormTabs?.length) {
            formBuilderInfo = {
              ...formBuilderInfo,
              fbPageFormTabs: formBuilderInfo.fbPageFormTabs.filter(x => {
                return !x.customTabJson || !(JSON.parse(x.customTabJson).selectedRoles?.length) || JSON.parse(x.customTabJson).selectedRoles.includes(fbRoleId);
              })
            };
            formBuilderInfo.fbPageFormTabIds = formBuilderInfo.fbPageFormTabs.map(x => x.pageFormTabId)
          }
          this.formBuilderInfo = formBuilderInfo;
          const isMultiDataSrcFlag = this.formBuilderInfo?.formBuilderPageFormButtons?.[0]?.isMultiDataSrc;
          this.isMultiDataSrc = isMultiDataSrcFlag ? isMultiDataSrcFlag : null;
          this.dashboardInfo = this.formBuilderInfo.dashboardInfo ? JSON.parse(this.formBuilderInfo.dashboardInfo) : null;
          sessionStorage.setItem('moduleId', this.formBuilderInfo.moduleId);
          sessionStorage.setItem('pageFormId', this.formBuilderInfo.id);
          sessionStorage.setItem('formName', this.formBuilderInfo?.formName);
          /* set ml or tab pageformid for redirecting back */
          if (formBuilderInfo.buildFormatTypeId !== 1482) {
            sessionStorage.setItem('mlPageFormId', this.formBuilderInfo?.id);
          }
          // Setup to handle tab back button redirection to previous page
          if (formBuilderInfo.buildFormatTypeId !== 1482) {
            const previousPageFormId = sessionStorage.getItem('previousPageFormId');
            const currentPageFormId = (this.formBuilderInfo?.id).toString();
            if (previousPageFormId && previousPageFormId !== currentPageFormId) {
              sessionStorage.setItem('prevRedirectPageFormId', previousPageFormId);
            }
            sessionStorage.setItem('previousPageFormId', currentPageFormId);
          }

          if (this.formBuilderInfo?.formName == "View Position") {
            sessionStorage.setItem('parentPageFormId', this.formBuilderInfo?.id);
          }
          if (this.formBuilderInfo?.formName !== "Edit Details (Bulk Upload)" && this.formBuilderInfo?.formName !== "View Position") {
            sessionStorage.removeItem('selectedjobposition');
            sessionStorage.removeItem('selectedjobpositionfbFormDataDTO');
            sessionStorage.removeItem('parentPageFormId');
          }
          if (isGetMenuList) {
            this.fbModuleService.onLoadMenuList.next({
              moduleId: this.formBuilderInfo.moduleId,
              formBuilderInfo: this.formBuilderInfo
            });
          } else if (!this.dashboardInfo || (this.dashboardInfo.dashboardType !== 'preDefTemplate')) {
            this.isShowPageTitleSection(onMenuClick);
          }
        }
        this.showPageInfo = true;
      });
  }

  isShowPageTitleSection(onMenuClick: boolean = false) {
    if (this.formBuilderInfo) {
      if (this.pageFormType === 'master_listing_table' && (this.showSimpleForm || onMenuClick)) {
        if (onMenuClick) {
          this.showPageTitleSection = true;
          this.showSimpleForm = false;
        } else if (this.showSimpleForm && this.simpleFormButton) {
          this.showPageTitleSection = false;
          this.getSimpleFormDetails();
        }
      } else if (['simple_form', 'form_builder_dashboard'].includes(this.pageFormType)) {
        this.showPageTitleSection = true;
        this.simpleFormButton = this.formBuilderInfo.formBuilderPageFormButtons[0];
        this.getSimpleFormDetails();
      }
    } else {
      this.showPageTitleSection = false;
      this.showSimpleForm = false;
      this.simpleFormButton = null;
    }
  }

  getInterviewRounds() {
    const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
    // this.interviewProcessId = fbFormDataDTO[1].interviewProcessSetupId
    //this.interviewProcessId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
    const interviewProcessSetupObj = fbFormDataDTO?.find(obj => obj.interviewProcessSetupId !== undefined);
    this.interviewProcessId = 'interviewProcessSetupId' in sessionStorage ? parseInt(sessionStorage.getItem('interviewProcessSetupId')) : null;

    if (this.interviewProcessId) {
      this.fdDetailNavSectionService.getInterviewRoundsById(this.interviewProcessId)
        .pipe(take(1))
        .subscribe((data: any[]) => {
          this.interviewRounds = data || [];
          this.onMultiStep();
        });
    }
  }


  getSteps(): any[] {
    if (this.simpleFormButton && this.simpleFormButton.pageFormJson) {
      const pageFormJson = JSON.parse(this.simpleFormButton.pageFormJson);
      if (Array.isArray(pageFormJson)) {
        let filteredFields = pageFormJson.filter(field => !('emptyCol' in field && field.emptyCol) && !(field.isOmit === true));
        if (this.isMultiDataSrc) {
          let uniqueRowNumbers = [];
          let tempFilterFields = [];
          filteredFields.forEach(field => {
            uniqueRowNumbers.push({ rowNumber: field.numberOfRow });
          });

          this.interviewRounds.forEach((round, index) => {
            tempFilterFields.push(...filteredFields.map((field, i) => {
              let groupName = field.groupName;
              let numberOfRow = field.numberOfRow;
              let uniqueName = field.name;

              const parts = groupName.split('_');
              const lastPart = parts.pop();
              const restOfString = parts.join('_');
              groupName = uniqueName + '-' + round.id + '_' + restOfString + '_' + this.appServicesLibraryService.uuid();
              const existingField = uniqueRowNumbers.find(item => item.rowNumber === numberOfRow);
              if (existingField) {
                numberOfRow = existingField.rowNumber;
              }

              return {
                ...field,
                stepNumber: index + 1,
                stepName: round.interviewType,
                groupName,
                stepId: round.id,
                name: groupName,
                numberOfRow
              };
            }));

          });
          filteredFields = [...tempFilterFields];
        }
        const uniqueStepNumbers = [...new Set(filteredFields.map(field => field.stepNumber || 1))];
        return uniqueStepNumbers.map(stepNumber => {
          const stepFields = filteredFields.filter(field => (field.stepNumber || 1) === stepNumber);
          const stepNameObj = stepFields?.find(obj => obj.stepName !== null);
          const stepLabel = stepFields.length > 0 ? stepNameObj?.stepName || `Step ${stepNumber}` : `Step ${stepNumber}`;
          return {
            label: stepLabel,
            simpleFormButton: this.simpleFormButton,
            pageFormType: this.pageFormType,
            formTypeSelected: this.formTypeSelected,
            isFBModulePreview: this.isFBModulePreview,
            formBuilderInfo: this.formBuilderInfo,
            formDataId: this.formDataId,
            stepNumber: stepNumber || 1,
            fields: stepFields,
          };
        }).filter((step, index, self) => {
          return index === self.findIndex(s => s.stepNumber === step.stepNumber);
        });
      }
    }

    return [
      {
        label: 'Step 1',
        simpleFormButton: this.simpleFormButton,
        pageFormType: this.pageFormType,
        formTypeSelected: this.formTypeSelected,
        isFBModulePreview: this.isFBModulePreview,
        formBuilderInfo: this.formBuilderInfo,
        formDataId: this.formDataId,
        stepNumber: 1,
        fields: [],
      },
    ];
  }

  getSimpleFormDetails() {
    this.referenceLibraryService.getReferenceData('FB_PAGE_TYPE')
      .pipe(take(1))
      .subscribe((response: any) => {
        this.fbPageTypeArr = response;
        if (this.simpleFormButton && this.fbPageTypeArr) {
          this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
          if (this.formTypeSelected !== 'POPUPVIEW') {
            if (this.formTypeSelected === 'MultiStep') {
              if (this.isMultiDataSrc) {
                this.getInterviewRounds();
              } else {
                this.onMultiStep();
              }
            } else {
              this.showSimpleForm = true;
            }
          } else {
            this.showSimpleForm = false;
            this.openPopup();
          }
        } else {
          this.showSimpleForm = false;
          this.isMultiStepForm = false;
        }
      });
  }

  onMultiStep() {
    this.steps = this.getSteps();
    this.showSimpleForm = false;
    this.isMultiStepForm = true;
    this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
  }

  private isValidItemSelection(item: TreeNode): boolean {
    const isItemSelected = item && item.pageFormId && item.formType;
    const isDifferentMenuSelected =
      !this.selectedMenu ||
      this.selectedMenu.value !== item.value ||
      this.formBuilderId !== item.pageFormId;

    const isSimpleFormConditionMet =
      this.showSimpleForm &&
      this.pageFormType === 'master_listing_table' &&
      FormType[item.formType] === 'master_listing_table';

    return isItemSelected && (isDifferentMenuSelected || isSimpleFormConditionMet);
  }

  private resetPageState(): void {
    this.pageFormType = null;
    this.formBuilderInfo = null;
    this.showPageTitleSection = false;
    this.showSimpleForm = false;
    this.simpleFormButton = null;
    this.formDataId = null;
    if (this.isMultiStepForm) {
      this.isMultiStepForm = false;
      this.formTypeSelected = null;
    }
  }

  private updatePageStateWithSelectedItem(item: TreeNode): void {
    this.selectedMenu = JSON.parse(JSON.stringify(item));
    this.formBuilderId = item.pageFormId;
    this.pageFormType = FormType[item.formType];
    this.getPageFormInfo(false, true);
  }

  onPageOpen(item: TreeNode) {
    this.dirtyCheckForFormsBuilder(item, 'OPENNEW');
  }
  onHandlePageOpen(item: TreeNode) {
    this.fdDetailNavSectionService.setisRedirectClicked(false);
    this.showPageInfo = false;
    if (this.isValidItemSelection(item)) {
      this.resetPageState();
      setTimeout(() => this.updatePageStateWithSelectedItem(item), 0);
    } else if (item && !item.pageFormId) {
      this.showPageInfo = true;
      this.resetPageState();
    } else {
      this.showPageInfo = true;
    }
  }

  onPageFormButtonClicked(item: any) {
    this.simpleFormButton = item;
    this.buttonClicked = true;
    sessionStorage.setItem('isButtonNew', 'true');
    if (this.formTypeSelected === 'MultiStep') {
      this.showSimpleForm = false;
      this.isMultiStepForm = true;
    } else {
      this.isMultiStepForm = false;
      this.showSimpleForm = true;
      this.isShowPageTitleSection();
    }
    this.formDataId = null;
    if(item.formUniqueName ="EMPLOYEE_BULK_UPLOAD") {
      sessionStorage.setItem('bulkformuniqueName', item.formUniqueName);
    }
    if ('fbFormDataDTO' in sessionStorage) {
      sessionStorage.removeItem('fbFormDataDTO');
    }
  }

  onBackToMasterList() {
    this.showSimpleForm = false;
    this.simpleFormButton = null;
      sessionStorage.setItem('isButtonNew', 'false');
    this.isShowPageTitleSection(true);
    this.isMultiStepForm = false;
    this.formTypeSelected = null;
    this.formDataId = null;
  }

  handleAction(e) {
    if (!e.isBeneficiaryProfileListing) {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      //this.showSimpleForm = true;
      if (this.fbPageTypeArr) {
        this.simpleFormButton = this.formBuilderInfo.formBuilderPageFormButtons[0];
        this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
      }
    } else {
      sessionStorage.setItem('FbEmployeeId', e.beneficiaryId);
      /* for Multi select edit */
      // if (e.redirectTo === 210) {
      //   this.showSimpleForm = true;
      //   this.isMultiStepForm = true;
      //   this.simpleFormButton = this.formBuilderInfo.formBuilderPageFormButtons[0];
      //   if (this.simpleFormButton) {
      //     this.getSimpleFormDetails();
      //   }
      // }

      // this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
      // setTimeout(() => {
      //   this.router.navigate([`../employee/profile/education`], {
      //     queryParams: {
      //       pageFrom: 'FB',
      //       fbEmpId: e.id
      //     },
      //     relativeTo: this.route
      //   });
      // }, 0);
    }
    if (e.isBeneficiaryProfileListing && e.redirectTo === 0) {
      this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
      setTimeout(() => {
        this.router.navigate([`../employee/profile/education`], {
          queryParams: {
            pageFrom: 'FB',
            fbEmpId: e.id
          },
          relativeTo: this.route
        });
      }, 0);
    } else {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      if (this.formTypeSelected === 'MultiStep') {
        this.steps = this.getSteps();
        this.showSimpleForm = false;
        this.isMultiStepForm = true;
        this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
        //this.buttonClicked = true;
      } else {
        this.isMultiStepForm = false;
        this.showSimpleForm = true;
      }
    }
  }

  dirtyCheckForFormsBuilder(item: TreeNode, type) {
    this.store.select(selectFormDirty).pipe(
      take(1)).subscribe(formState => {
        if (!formState.dirty) {
          if (type && type === 'OPENNEW') {
            this.onHandlePageOpen(item);
          } else {
            this.onHandleRedirectPage(item);
          }
        } else {
          this.ngxService.stopAll();
          return this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
              },
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).beforeClosed().pipe(take(1)).subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({
                dirty: false
              }));
              if (type && type === 'OPENNEW') {
                this.onHandlePageOpen(item);
              } else {
                this.onHandleRedirectPage(item);
              }
            }
          });

        }
      });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

}
